import {
  IS_TENANT_MGM_LOADING,
  TENANT_SWITCHER_LOADING,
  SHOW_ACTION_STATUS,
  SET_SIDECAR_OPTIONS,
} from './actions/ViewReducer.actions'

/**
 * Created by vsuthar on 9/15/21
 * File: GloablViewReducer
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

const initState = {
  isTenantSwitcherLoading: false,
  isTenantMgmLoading: false,
  showActionStatus: 'NONE',
  sidecar: {
    isOpen: false,
    title: '',
    body: '',
    extra: {}
  }
}

const ViewReducer = (state = initState, action) => {
  switch (action.type) {
    case TENANT_SWITCHER_LOADING: {
      return { ...state, isTenantSwitcherLoading: action.isTenantSwitcherLoading }
    }
    case IS_TENANT_MGM_LOADING: {
      return { ...state, isTenantMgmLoading: action.isTenantMgmLoading }
    }
    case SHOW_ACTION_STATUS: {
      return { ...state, showActionStatus: action.showActionStatus }
    }
    case SET_SIDECAR_OPTIONS: {
      return { ...state, sidecar: action.sidecar }
    }
    default: {
      return state
    }
  }
}

ViewReducer.initialState = initState
export default ViewReducer
